import React from "react";
import BreadCrumbComp from "../../../components/breadCrumb";
import FormTextField from "../../../components/textField/formTextField";
import FormCalendar from "../../../components/calendar/formCalendar";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import LaddaButton from "../../../components/buttons/laddaButton";
import SimpleSelect from "../../../components/selects/simpleSelect";
import { useEffect } from "react";
import { useState } from "react";
import {
  addOrUpdateServiceSuppliers,
  callApiAsync,
  getCallProcess
} from "../../../services/apiService";
import { useLocation, useNavigate } from "react-router-dom";
import { canManageServiceSuppliers } from "../../../constants/supplierRoles";

const CreateServicesSuppliers = () => {
  const [process, setProcess] = useState([]);

  const navigate = useNavigate();

  const location = useLocation();
  const rowData = location.state?.data;

  const validationSchema = yup.object().shape({
    supplier_name: yup.string().required("Nombre requerido"),
    nit: yup.string().required("NIT requerido"),
    address: yup.string().required("Dirección requerida"),
    city: yup.string().required("Ciudad requerida"),
    process_id: yup.string().required("Proceso requerido"),
    contact_name: yup.string().required("Nombre de contacto requerido"),
    phone: yup.string().required("Teléfono requerido"),
    email: yup.string().required("Correo requerido"),
    provided_service: yup.string().required("Servicio requerido")
  });

  const setValues = (data) => {
    setValue("supplier_name", data.supplier_name || "");
    setValue("nit", data.nit || "");
    setValue("address", data.address || "");
    setValue("city", data.city || "");
    setValue("contact_name", data.contact_name || "");
    setValue("phone", data.phone || "");
    setValue("email", data.email || "");
    setValue("provided_service", data.provided_service || "");
    if (data.process_id) {
      setValue("process_id", data.process_id);
    }
  };

  const userData = useSelector((state) => state.userData.userData);
  const isSupplierManagment = canManageServiceSuppliers(userData.roleList);

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    watch
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onSubmit"
  });

  const getProcess = async () => {
    callApiAsync(getCallProcess, (data) => {
      setProcess(data);
    });
  };

  const onSubmit = async (data) => {
    const dataToSend = {
      ...data,
      id: rowData ? rowData.id : 0,
      creator_user_id: userData.id
    };

    await callApiAsync(
      () => addOrUpdateServiceSuppliers(dataToSend),
      () => {
        navigate("/suppliers/services_suppliers");
      }
    );
  };

  useEffect(() => {
    getProcess();
  }, []);

  useEffect(() => {
    if (rowData && rowData.id !== 0) {
      setValues(rowData);
    }
  }, [rowData]);

  return (
    <div>
      <BreadCrumbComp />
      <div className="searchTitle">
        <h1>
          {rowData?.id == 0 ? "CREAR NUEVO" : "EDITAR"} PROVEEDOR DE SERVICIOS
        </h1>
      </div>
      <div className="table-container">
        <h1 className="title-bio-details-chard vm-20">
          Proveedor de Servicios
        </h1>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Nombre del Proveedor:</p>
            <FormTextField
              name="supplier_name"
              control={control}
              error={errors.supplier_name}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Nit:</p>
            <FormTextField
              name="nit"
              control={control}
              error={errors.nit}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Dirección Principal:</p>
            <FormTextField
              name="address"
              control={control}
              error={errors.address}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Ciudad*:</p>
            <FormTextField
              name="city"
              control={control}
              error={errors.city}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Proceso al que pertenece:</p>
            <SimpleSelect
              name="process_id"
              control={control}
              options={process}
              error={errors.process_id}
              margin={"0"}
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Nombre de Contacto:</p>
            <FormTextField
              name="contact_name"
              control={control}
              error={errors.contact_name}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Teléfono:</p>
            <FormTextField
              name="phone"
              control={control}
              error={errors.phone}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Correo Electrónico*:</p>
            <FormTextField
              name="email"
              control={control}
              error={errors.email}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <p className="create-label ml-0">Servicio Prestado:</p>
            <FormTextField
              name="provided_service"
              control={control}
              error={errors.provided_service}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
        </Grid>
        <br />
        {isSupplierManagment && (
          <div className="HContainer j-center w-complete">
            <LaddaButton variant="contained" onClick={handleSubmit(onSubmit)}>
              <div className="HContainer align-center">
                <p className="button_text">
                  {rowData?.id == 0 ? "Crear" : "Editar"} Proveedor Farmacéutico Nacional
                </p>
              </div>
            </LaddaButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateServicesSuppliers;
